<svg width="50" height="50">
    <g transform="rotate(-90 25,25) translate(-12,0)">
        <path class="settings-tile-svg-fill tile__svg-fill"
              [attr.d]="circlePath3"
              [attr.fill-opacity]="value > 2 ? 1 : 0.2"
              transform="rotate(25 25,25)" stroke="none">
        </path>
        <path class="settings-tile-svg-fill tile__svg-fill"
              [attr.d]="circlePath2"
              [attr.fill-opacity]="value > 1 ? 1 : 0.2"
              transform="rotate(25 25,25)" stroke="none">
        </path>
        <path class="settings-tile-svg-fill tile__svg-fill"
              [attr.d]="circlePath1"
              [attr.fill-opacity]="value > 0 ? 1 : 0.2"
              transform="rotate(25 25,25)" stroke="none">
        </path>
        <circle cx="25" cy="25" r="4" class="settings-tile-svg-fill tile__svg-fill"></circle>
    </g>
</svg>
